module.exports = __webpack_public_path__ + "img/ico199.12cb92cc.svg";